import { AppointmentDto, AppointmentId, EtxeApiPrefixes, EtxeApiSlugs } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';

export class AppointmentsConnector extends ApiConnector<AppointmentDto, AppointmentDto, AppointmentId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, EtxeApiSlugs.APPOINTMENTS);
  }

  getMyAppointments = (params?: {
    from?: string;
    to?: string;
    status?: string;
  }): Observable<AppointmentDto[]> => {
    const queryParams: Record<string, string> = {};
    if (params?.from) queryParams['from'] = params.from;
    if (params?.to) queryParams['to'] = params.to;
    if (params?.status) queryParams['status'] = params.status;

    return this.apiCaller.getRequest<AppointmentDto[]>(
      EtxeApiPrefixes.CORE,
      this.slug,
      Object.keys(queryParams).length > 0 ? { params: queryParams } : undefined,
    );
  };
}
